import { useContext } from "react"

import { ProductSheetGroupContext } from "~/pages/Brand/CommunicationStudio/contexts/productSheetGroup/ProductSheetGroupContext"

export const useProductSheetGroup = () => {
  const ctx = useContext(ProductSheetGroupContext)
  if (!ctx) {
    throw new Error(
      "useProductSheetGroup must be used within a ProductSheetGroupProvider"
    )
  }
  return ctx
}
